import Component from '../component';

export default class BlockMap extends Component {
	constructor(...args) {
		super(...args);
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/block-map/block-map.js